/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Athletic_PerformanceInputs */

const en_service_type_athletic_performance = /** @type {(inputs: Service_Type_Athletic_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Athletic performance`)
};

const pl_service_type_athletic_performance = /** @type {(inputs: Service_Type_Athletic_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotowanie motoryczne`)
};

/**
* | output |
* | --- |
* | "Athletic performance" |
*
* @param {Service_Type_Athletic_PerformanceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_athletic_performance = /** @type {((inputs?: Service_Type_Athletic_PerformanceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Athletic_PerformanceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_athletic_performance(inputs)
	return en_service_type_athletic_performance(inputs)
});